import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Cart, UserIdService } from '@spartacus/core';
import { filter, switchMap, take } from 'rxjs/operators';
import { ActiveCartService } from './active-cart.service';

/**
 * Данный сервис предназначен для сохранения корзины анонима в момент мержа корзин. Как только пользователь авторизуется
 * activeCartService.getActive сначала отдает неактуальную корзину, поэтому мы сохраняем снапшот корзины, чтобы знать
 * её code, по которому можно делать проверку и не отправлять запросы к устаревшей корзине
 */
@Injectable({
  providedIn: 'root',
})
export class CartStateSnapshotService {
  private _previousCart: Cart | null = null;

  constructor(
    private userIdService: UserIdService,
    private destroyRef: DestroyRef,
    private activeCartService: ActiveCartService,
  ) {}

  initCartSnapshotService(): void {
    this.userIdService
      .getUserId()
      .pipe(
        filter(Boolean),
        // Берём текущее состояние корзины и сохраняем снапшот
        switchMap(() => this.activeCartService.getActive().pipe(take(1))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((cart) => {
        if (cart.user?.uid === 'anonymous') {
          this._previousCart = cart;
        }
      });
  }

  /** Достаём ID старой корзины */
  public get previousCartId(): string | undefined {
    return this._previousCart?.code;
  }
}
